import script from "./DemoViewMKII.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoViewMKII.vue?vue&type=script&setup=true&lang=js"

import "./DemoViewMKII.vue?vue&type=style&index=0&id=d8e9edda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8e9edda"]])

export default __exports__